module.exports = __webpack_public_path__ + "static/downloable/calendario_pagos_RRVV_2026.5622c7e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/calendario_pagos_RRVV_2026.pdf
// module id = U3rm
// module chunks = 1